import { CircularProgress, List, ListItem, Divider } from "@mui/material";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    minWidth: '520px',
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, fontFamily: "Quicksand" }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export const CreateJobroles = ({
  JobhandleClose,
  JobOpen,
  Job,
  setJob,
  createJobRole,
  isLoading,
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={JobhandleClose}
      aria-labelledby="customized-dialog-title"
      open={JobOpen}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={JobhandleClose}
      >
        <div className="foundation_header">Create Job Role</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Form_Box">
          <div className="Box">
            <label>name</label>
            <input
              name="name"
              value={Job.name}
              onChange={(e) => setJob({ ...Job, name: e.target.value })}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={JobhandleClose} className="Btn">
            Cancel
          </button>
          <button
            className="Btn"
            onClick={createJobRole}
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
          >
            {isLoading === true ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "submit"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const EditJobroles = ({
  handleEditJobClose,
  EditJob,
  Job,
  setJob,
  AllJobs,
  updateJobRole,
  isLoading,
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={handleEditJobClose}
      aria-labelledby="customized-dialog-title"
      open={EditJob !== null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleEditJobClose}
      >
        <div className="foundation_header">Edit Job Role</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Form_Box">
          <div className="Box">
            <label>name</label>
            <input
              name="name"
              value={Job.name}
              placeholder={
                AllJobs !== ""
                  ? AllJobs?.find((item) => item.id === EditJob)?.name
                  : ""
              }
              onChange={(e) => setJob({ ...Job, name: e.target.value })}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={handleEditJobClose} className="Btn">
            Cancel
          </button>
          <button
            className="Btn"
            onClick={updateJobRole}
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
          >
            {isLoading === true ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "submit"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const DeleteJobroles = ({
  handleDeleteJobClose,
  DeleteJob,
  deleteJobRole,
  isLoading,
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={handleDeleteJobClose}
      aria-labelledby="customized-dialog-title"
      open={DeleteJob !== null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleDeleteJobClose}
      >
        <div className="foundation_header">Delete Job</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Confirmation">Are you sure?</div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={handleDeleteJobClose} className="Btn">
            Cancel
          </button>
          <button
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
            className="Delete_Btn"
            onClick={deleteJobRole}
          >
            {isLoading === true ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "Delete"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const ViewJobDialog = ({
  handleViewJobClose,
  JobViewopen,
}) => {
  return (
    <BootstrapDialog
      onClose={handleViewJobClose}
      aria-labelledby="customized-dialog-title"
      open={JobViewopen !== null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleViewJobClose}
      >
        <div className="foundation_header">View Job Role</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <List>
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <label>Name</label>
            <p>{JobViewopen?.name}</p>
          </ListItem>
        </List>
      </DialogContent>
    </BootstrapDialog>
  );
};
